import useBulkCopyTimeLogsMutation from "@timenotes/shared/src/services/time-logs/queries/use-bulk-copy-time-logs-mutation"
import { Modal, ModalProps, message } from "antd"
import { useFormik } from "formik"
import useApiClient from "hooks/useApiClient"
import moment from "moment-timezone"
import { useEffect, useState } from "react"
import { useQueryClient } from "react-query"
import useQueryGenericErrorMessage from "services/utils/hooks/use-query-generic-error-message"
import { BulkDateFormFields, getBulkFormFieldInitialValues } from "./forms/bulk-date-form-fields"

type useBulkCopyProps = ModalProps & {
  ids: string[]
}

export const useBulkCopyTimeLogs = ({ ids, ...props }: useBulkCopyProps) => {
  const [open, setOpen] = useState(false)
  const apiClient = useApiClient()
  const queryClient = useQueryClient()


  const bulkCopyTimeLogsMutation = useBulkCopyTimeLogsMutation()

  useEffect(() => {
    if (open && ids.length == 0) {
      setOpen(false)
      message.error('No time logs selected for bulk delete!')
    }
  }, [open])

  useEffect(() => {
    if (bulkCopyTimeLogsMutation.isSuccess) {
      if (props.onOk) props.onOk(undefined as any)
      setOpen(false)
    }
  }, [bulkCopyTimeLogsMutation.isLoading])

  useQueryGenericErrorMessage(bulkCopyTimeLogsMutation)

  useEffect(() => {
    if (open && ids.length == 0) {
      setOpen(false)
      message.error('No time logs selected for bulk copy!')
    }
  }, [open])

  const handleBulkCopy = async () => {
    const startDate = formik.values.startDate.format('YYYY-MM-DD')
    const endDate = formik.values.endDate.format('YYYY-MM-DD')
    const singleDate = formik.values.singleDate.format('YYYY-MM-DD')
    const isSingleDate = formik.values.isSingleDate

    bulkCopyTimeLogsMutation.mutate({
      timeLogsIds: ids,
      startDate: isSingleDate ? singleDate : startDate,
      endDate: isSingleDate ? singleDate : endDate,
      onlyWorkingDays: formik.values.onlyWorkingDays,
    })
  }

  const formik = useFormik({
    initialValues: getBulkFormFieldInitialValues(),
    onSubmit: () => {
      handleBulkCopy()
    }
  })

  const BulkCopyModal = (
    <Modal 
      visible={open}
      okText="Copy"

      confirmLoading={bulkCopyTimeLogsMutation.isLoading}
      title={`Copy ${ids.length} selected time logs into day(s)`}
      {...props}

      onOk={handleBulkCopy}
      onCancel={(e) => {
        if (props.onCancel) props.onCancel(e)
        setOpen(false)
      }}
    >
      <BulkDateFormFields 
        formik={formik}
      />
   </Modal>
  )

  return {
    modal: BulkCopyModal,
    open: open,
    setOpen: setOpen,
  }
}